module.exports = __webpack_public_path__ + "static/media/emoticon-emoticons-emotion-expression-face-svgrepo-com (1).ca735aa4.svg";